import { render, staticRenderFns } from "./DocumentCommentEdit.vue?vue&type=template&id=23f8aaa6&"
import script from "./DocumentCommentEdit.vue?vue&type=script&lang=js&"
export * from "./DocumentCommentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports